/**
 * Editorial hero used at top of inner pages.
 * Props:
 *  - eyebrow: small uppercase label (e.g. "— About Us")
 *  - title:  large display title
 *  - subtitle: short paragraph below title
 *  - image: optional background/feature image url
 *  - imageFit: "cover" (default) crops to fill the 4:3 frame; "contain"
 *    shows the full image without cropping (use for maps, infographics,
 *    logos, etc. where the original composition must be preserved).
 */
export default function PageHero({
  eyebrow,
  title,
  subtitle,
  image,
  imageFit = "cover",
}) {
  return (
    <section className="relative bg-[#fafaf7] border-b border-[#e2e8f0]/80 overflow-hidden">
      <div className="max-w-7xl mx-auto px-6 md:px-10 py-16 md:py-24 grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16 items-end">
        <div className="lg:col-span-7 reveal">
          {eyebrow ? <span className="eyebrow">{eyebrow}</span> : null}
          <h1 className="font-display text-4xl md:text-6xl lg:text-7xl text-[#1a365d] leading-[1.04] tracking-tight mt-5">
            {title}
          </h1>
          {subtitle ? (
            <p className="font-body text-[#475569] text-base md:text-lg leading-relaxed max-w-2xl mt-6">
              {subtitle}
            </p>
          ) : null}
        </div>
        {image ? (
          <div className="lg:col-span-5 reveal delay-1">
            <div
              className={`w-full ${
                imageFit === "contain"
                  ? "flex items-center justify-center bg-white aspect-[4/3]"
                  : "zoom-wrap aspect-[4/3]"
              }`}
            >
              <img
                src={image}
                alt={typeof title === "string" ? title : "Tesori d'Europa"}
                loading="lazy"
                className={`${
                  imageFit === "contain"
                    ? "max-w-[88%] max-h-[88%] object-contain"
                    : "w-full h-full object-cover"
                }`}
              />
            </div>
          </div>
        ) : null}
      </div>
    </section>
  );
}
